import React from 'react';
import Events, { type EventsProps } from '../../../react4xp/components/EventCard'

function EventsPart(props: EventsProps) {
  return (
    <Events {...props} />
  )
}

export default (props: EventsProps) => <EventsPart {...props} />